<template>
  <div :class="['lk-input', { 'lk-input--error': error }, { 'lk-input--valid': valid }]">
    <input
      :value="value"
      :name="name"
      @input="emitChange($event.target.value)"
      class="lk-input__input"
      @blur="handleBlur"
      @focus="handleFocus"
      @click="handleClick"
      v-bind="$attrs"
    />
    <slot name="action" />
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    name: {
      type: String,
      default: undefined,
    },
    error: Boolean,
    valid: Boolean,
  },
  methods: {
    handleBlur() {
      this.$emit('blur', { name: this.name })
    },
    handleFocus(e) {
      this.$emit('focus', e)
    },
    handleClick(e) {
      this.$emit('click', e)
    },
    emitChange(value) {
      this.$emit('input', value)
      this.$emit('change', { name: this.name, value })
    },
  },
}
</script>

<style lang="sass">
.lk-input
  display: flex
  gap: 10px
  padding: 11px 24px
  background-color: #fff
  color: #424242
  width: 100%
  line-height: 140%
  transition: all .2s
  font-family: Segoe UI, sans-serif
  border: 1px solid #e7e7e8
  border-radius: 6px
  font-size: 14px

  &:focus-within
    border: 1px solid #00c8d7

  &--error
    border-color: #ec7c7c

  &--valid
    border-color: #00c8d7

  &__input
    width: 100%
    background-color: #fff
</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-input/index.vue